// routes/FrontendRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import EmailFeedback from '../components/Frontend/EmailFeedback';

export const emailFeedbackRoute = (
  <>
  <Route path="/email_feed_back/save" element={<EmailFeedback />} />
  </>
);
